var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.53 23.06C17.8979 23.06 23.06 17.8978 23.06 11.53C23.06 5.16213 17.8979 0 11.53 0C5.16218 0 0 5.16213 0 11.53C0 17.8978 5.16218 23.06 11.53 23.06Z",
    fill: "#FEC25A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6408 11.5378C18.5773 15.4658 15.4507 18.5923 11.5228 18.6558C7.59479 18.7193 4.4683 15.3706 4.40482 11.5378C4.39688 10.9506 3.4843 10.9506 3.49224 11.5378C3.56366 15.9657 7.09486 19.489 11.5148 19.5604C15.9427 19.6318 19.4739 15.8467 19.5453 11.5378C19.5612 10.9506 18.6567 10.9506 18.6408 11.5378Z",
    fill: "#425364"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02021 9.36361C9.01943 9.36361 9.82939 8.55356 9.82939 7.55434C9.82939 6.55512 9.01943 5.74512 8.02021 5.74512C7.02099 5.74512 6.21094 6.55512 6.21094 7.55434C6.21094 8.55356 7.02099 9.36361 8.02021 9.36361Z",
    fill: "#425364"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8718 9.36361C15.871 9.36361 16.6809 8.55356 16.6809 7.55434C16.6809 6.55512 15.871 5.74512 14.8718 5.74512C13.8726 5.74512 13.0625 6.55512 13.0625 7.55434C13.0625 8.55356 13.8726 9.36361 14.8718 9.36361Z",
    fill: "#425364"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileIcon);
export default __webpack_public_path__ + "static/media/smileIcon.e036e3d7c96f5168e7e5aefb33664979.svg";
export { ForwardRef as ReactComponent };